import { render, staticRenderFns } from "./IconNews.vue?vue&type=template&id=72f178e2&scoped=true"
import script from "./IconNews.vue?vue&type=script&setup=true&lang=js"
export * from "./IconNews.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f178e2",
  null
  
)

export default component.exports